const state = {
  campaignMaster: [],
  customerMaster: {},
  reports: {},
  soldToCode:[],
  purposeType:[],
  nerpCampingMaster: [],
  getProductTypeCampaign: [],
  };
  
  export default state;